import { apiGet } from "../utils/api/apiRaw";

export const getNavigation = function() {
  return apiGet("plus/navigation");
};
